module.exports = __webpack_public_path__ + "img/arrow.11f131fb.svg";